import { render, staticRenderFns } from "./ProductCenterGridSpeaker.vue?vue&type=template&id=5d25d880&scoped=true"
import script from "./ProductCenterGridSpeaker.vue?vue&type=script&lang=js"
export * from "./ProductCenterGridSpeaker.vue?vue&type=script&lang=js"
import style0 from "./ProductCenterGridSpeaker.vue?vue&type=style&index=0&id=5d25d880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d25d880",
  null
  
)

export default component.exports